'use strict';

(function () {
  'use strict';

  angular.module('msUtility').directive('msAriaSrefActive', msAriaSrefActive);

  msAriaSrefActive.$inject = ['$log'];

  function msAriaSrefActive($log) {
    var directive = {
      link: link,
      restrict: 'A',
      scope: false
    };
    return directive;

    // Watches for changes to the element's class list,
    // compares the classes to the value in uiSrefActive
    // then adds `aria-selected=true` when that state is active.
    // Adds `aria-selected=false` when that class gets removed.
    function link(scope, element, attr) {
      if (!attr.uiSrefActive) {
        $log.warn('This directive must be used with uiSrefActive.');
      } else {
        scope.$watch(function () {
          return element.attr('class');
        }, function (newVal) {
          _.includes(newVal, attr.uiSrefActive) ? element.attr('aria-selected', true) : element.attr('aria-selected', false);
        });
      }
    }
  }
})();